

export class EmployeeDetailsStatusInput implements IEmployeeDetailsStatusInput {
    /** The auto-generated id of the branch details master */
    employeeDetailsId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IEmployeeDetailsStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeDetailsId = _data["employeeDetailsId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): EmployeeDetailsStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDetailsStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeDetailsId"] = this.employeeDetailsId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IEmployeeDetailsStatusInput {
    /** The auto-generated id of the branch details master */
    employeeDetailsId: number;
    /** The updated status */
    status: number;
}

